/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { map } from 'rxjs/operators';
import { Observable, forkJoin } from 'rxjs';
import { Options } from '@api/models/options';
import { ApiResParserService } from '@api/services/api-res-parser/api-res-parser.service';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '@api/services/api/api.service';
import { Injectable } from '@angular/core';
import {
  DomainListDTO,
  QuotationBoundariesDTO
} from '@core/modules/api/models';

@Injectable()
export class ApiCustomService extends ApiService {
  constructor(
    protected http: HttpClient,
    protected parser: ApiResParserService
  ) {
    super(http, parser);
  }

  getQuotationBoundaries(
    positionId: string,
    options?: Options
  ): Observable<QuotationBoundariesDTO> {
    const url = `${this.apiUrl}/v1/quotations/calculate/revolving/credituse/range?positionId=${positionId}`;

    return forkJoin([
      this.getDomain('MAX_DURATION'),
      this.http.get<{
        payload: {
          minRequestable: number;
          maxRequestable: number;
          minDuration: number;
          maxDuration: number;
        };
      }>(url)
    ]).pipe(
      map(res => {
        const durations = res[0];
        const range = res[1];

        return {
          financedMaxAmount: range.payload.maxRequestable,
          financedMinAmount: range.payload.minRequestable,
          instalmentMaxAmount:
            range.payload.maxRequestable / range.payload.minDuration,
          instalmentMinAmount: null,
          durationMin: range.payload.minDuration,
          durationMax: range.payload.maxDuration,
          durationSteps: this.calcDurationStep(durations),
          purposes: [{ description: 'CQS', code: 'CQS' }]
        };
      }),
      map(res => this.parser.quotationBoundaries(res))
    );
  }

  private calcDurationStep(domain: DomainListDTO): number {
    const durations = domain.domainList
      .sort((a, b) => Number(a.key) - Number(b.key))
      .filter(
        (item, index, arr) => arr.findIndex(x => x.key === item.key) === index
      );

    const first =
      durations[0] && durations[0].key ? Number(durations[0].key) : 0;
    const second =
      durations[1] && durations[1].key ? Number(durations[1].key) : 0;
    const diff = second - first;

    return diff <= 0 ? 1 : diff;
  }
}
